import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../api";

export default function ForgotPassword() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [ok, setOk] = useState("");

  const validate = () => {
    const e = String(email || "").trim().toLowerCase();
    if (!e) return "Email is required.";
    if (!/^\S+@\S+\.\S+$/.test(e)) return "Enter a valid email.";
    return "";
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const msg = validate();
    if (msg) return setErr(msg);

    setLoading(true);
    setErr("");
    setOk("");

    try {
      const resp = await API.post("/auth/forgot-password", {
        email: String(email).trim().toLowerCase(),
      });

      setOk(
        resp?.data?.message ||
          "If this email exists, a reset link has been sent."
      );

      // optional: auto navigate after short delay
      setTimeout(() => navigate("/login"), 1200);
    } catch (e2) {
      console.error(e2);
      setErr(
        e2?.response?.data?.error ||
          e2?.response?.data?.message ||
          "Failed to request password reset."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 20, display: "flex", justifyContent: "center",height: '100vh', alignItems: 'center' }}>
      <div
        style={{
          width: 420,
          maxWidth: "95vw",
          border: "1px solid #eee",
          borderRadius: 12,
          padding: 16,
          background: "#fff",
        }}
      >
        <h2 style={{ marginTop: 0 }}>Forgot Password</h2>

        {err && (
          <div
            style={{
              background: "#ffecec",
              border: "1px solid #ffb8b8",
              color: "#8a1f1f",
              padding: 10,
              borderRadius: 10,
              marginBottom: 10,
            }}
          >
            {err}
          </div>
        )}
        {ok && (
          <div
            style={{
              background: "#eaffea",
              border: "1px solid #b7f0b7",
              color: "#155d15",
              padding: 10,
              borderRadius: 10,
              marginBottom: 10,
            }}
          >
            {ok}
          </div>
        )}

        <form onSubmit={onSubmit}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 6,
              marginBottom: 12,
            }}
          >
            <label style={{ fontSize: 12, fontWeight: 700 }}>Email</label>
            <input
              type="email"
              value={email}
              onChange={(ev) => setEmail(ev.target.value)}
              placeholder="Enter your email"
              autoComplete="email"
              style={{
                padding: 10,
                borderRadius: 10,
                border: "1px solid #d9d9d9",
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: 10,
              borderRadius: 10,
              border: "1px solid #111",
              background: "#111",
              color: "#fff",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </button>

          <div style={{ marginTop: 10, fontSize: 12, color: "#666" }}>
            You’ll receive a reset link if your email exists in the system.
          </div>
        </form>
      </div>
    </div>
  );
}
